import { ref, computed } from 'vue'
import i18next from '@/config/i18n'
import { LANGUAGES, DEFAULT_LANGUAGE } from '@/constants/languages'

// `i18next.language` is a plain property and does not participate in Vue's
// reactivity system. We mirror it into a module-level ref so any consumer
// (computed, watch, template) re-evaluates when the language changes.
const languageRef = ref(i18next.language)
i18next.on('languageChanged', (lng) => {
  languageRef.value = lng
})

export function useLanguage() {
  const changeLanguage = async (lng) => {
    if (lng in LANGUAGES) {
      await i18next.changeLanguage(lng)
    }
  }

  const currentLanguage = computed(() => {
    const lang = languageRef.value
    return lang in LANGUAGES ? lang : DEFAULT_LANGUAGE
  })

  const currentLanguageConfig = computed(() => {
    return LANGUAGES[currentLanguage.value]
  })

  return {
    currentLanguage,
    currentLanguageConfig,
    changeLanguage
  }
}
